module.exports = __webpack_public_path__ + "static/media/lifestyle_freetime-min.0a7c2e71.jpg";